// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"52":"afc3c7b7","93":"70d9b4f0","371":"7aa3c347","488":"6d22fdcd","513":"c3931144","567":"dce10ec6","719":"7041b55e","787":"dfb034e2","877":"2b51d9f5"}[chunkId] + ".chunk.js";
};